export const INDEX_SECTORS_OF_INTEREST_ATTEMPT = 'INDEX_SECTORS_OF_INTEREST_ATTEMPT';
export type INDEX_SECTORS_OF_INTEREST_ATTEMPT = typeof INDEX_SECTORS_OF_INTEREST_ATTEMPT;

export const INDEX_SECTORS_OF_INTEREST_SUCCESS = 'INDEX_SECTORS_OF_INTEREST_SUCCESS';
export type INDEX_SECTORS_OF_INTEREST_SUCCESS = typeof INDEX_SECTORS_OF_INTEREST_SUCCESS;

export const INDEX_SECTORS_OF_INTEREST_FAILURE = 'INDEX_SECTORS_OF_INTEREST_FAILURE';
export type INDEX_SECTORS_OF_INTEREST_FAILURE = typeof INDEX_SECTORS_OF_INTEREST_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/sector-of-interest/index/Types.tsx